import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_NARWHAL_TOPIC_STRUCTURED_DATA = defineFcm('narwhal_topic_structured_data')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				content: {
					type: 'array',
					shape: {
						type: 'object',
						shape: {
							slug: { type: 'string' },
							content: {
								type: 'array',
								shape: {
									type: 'object',
									shape: {
										title: { type: 'string' },
										id: { type: 'string' },
										content: { type: 'string' },
									},
								},
							},
						},
					},
				},
			},
		}),
	)
	.withDefault({
		enabled: false,
		content: [],
	})
	.toConfig({
		owner: 'squad-narwhal',
		scope: ['corgi-front-end', 'corgi-middle-end'],
		context: 'Topic pages',
		description: 'Content to be used in structured data for topic pages',
		import: false,
		template: {
			enabled: false,
			content: [
				{
					slug: 'example-topic-slug',
					content: [
						{
							title: 'string',
							id: 'string',
							content: 'string',
						},
					],
				},
			],
		},
	});
